/*
 * Copyright (c) 2020. American Express Company
 */

import React, { ReactComponentElement } from 'react';

import BackButton from '../../components/back-button/BackButton';
import BasicDrawer from './common/BasicDrawer';
import PlaidButton from './PlaidButton';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './ZeroExpensesDrawer.scss';

export default class ZeroExpensesDrawer extends BasicDrawer<
    any,
    {
        banking: boolean;
        credit: boolean;
        investment: boolean;
        loan: boolean;
    }
> {
    public override state: any = {
        banking: true,
        credit: true,
        investment: true,
        loan: true
    };

    public override render(): ReactComponentElement<any> {
        return (
            <div className="zero-expenses-drawer drawer">
                <BackButton drawerProps={this.props.drawerProps} handleBack={this.props.handleBack} />
                <Typography variant={TypographyVariants.HEADING_S} className="page-title">
                    Average Monthly Expenses
                </Typography>
                <PlaidButton
                    handleClearFirstImport={this.props.handleClearFirstImport}
                    handleFirstImport={this.props.handleFirstImport}
                    handleReloadUser={this.props.handleReloadUser}
                    firstImport={this.props.firstImport}
                    setDrawer={this.props.setDrawer}
                    className="plaid-link"
                    user={this.props.user}
                    handleAccounts={this.props.handleAccounts}
                />
                <Typography variant={TypographyVariants.BODY}>
                    Unable to connect your accounts? You can also:
                    <p
                        className="link"
                        onClick={() => {
                            this.props.handleAddExpense();
                        }}
                    >
                        Manually enter your average monthly expenses.
                    </p>
                </Typography>
            </div>
        );
    }
}
